import { PaymentMethod } from "@types-runway/billing";

// The payCase saga only waits for a payment-method attach to finish when
// paymentMethods.length === 0 — a heuristic that holds for the card form
// (it only attaches a new method when the user has none saved) but not for
// Apple Pay/Link, which always attach a fresh method regardless of how many
// the user already has. Forcing an empty array when a method was just
// attached makes the saga wait correctly for that case, instead of racing
// ahead to /invoice + /pay before the new method (and its "set as default")
// has actually finished.
export const resolvePaymentMethodsForPayCase = (
  paymentMethods: PaymentMethod[],
  justAttachedPaymentMethod: boolean
): PaymentMethod[] => (justAttachedPaymentMethod ? [] : paymentMethods);
